






























import { defineComponent } from '@vue/composition-api';

const name = 'ttam-expand-button';
export default defineComponent({
  name,
  provide() {
    // 避免 viForm 的状态会影响 viButton
    return {
      viForm: '',
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    // 要展开的内容
    content: {
      type: String,
      default: '',
    },
    // 展开后的icon
    expandIcon: {
      type: String,
      default: 'vi-icon2-arrowup-double',
    },
    // 展开前的icon
    normalIcon: {
      type: String,
      default: 'vi-icon2-arrowdown-double',
    },
    expand: {
      type: Boolean,
      default: false,
    },
    // 埋点
    dataTea: {
      type: String,
      default: '',
    },
    dataTeaExpose: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('update:expand', !props.expand);

      emit('expand', !props.expand);
    };
    return {
      name,
      onClick,
    };
  },
});
